webpackJsonp([74],{

/***/ "/o5o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/Modal.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Modal = ({
  props: {
    open: {
      type: Boolean,
      default: false
    },

    width: {
      type: [Number, String],
      default: function _default() {
        return '75%';
      }
    }
  },

  methods: {
    close: function close() {
      this.$emit('close');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-362add64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"mu-modal-slide"}},[(_vm.open)?_c('div',{staticClass:"mu-modal-wrapper",on:{"click":_vm.close}},[_c('div',{staticClass:"mu-modal",style:({width: this.width}),on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"mu-modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"mu-action",on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("action")],2)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Modal = (esExports);
// CONCATENATED MODULE: ./src/components/Modal.vue
function injectStyle (ssrContext) {
  __webpack_require__("6N2g")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Modal,
  components_Modal,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_Modal = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0MKX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var qrCode = function qrCode() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(55)]).then(__webpack_require__.bind(null, "RHuS"));
};
var preview = function preview() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(16)]).then(__webpack_require__.bind(null, "Clt1"));
};

/* harmony default export */ __webpack_exports__["default"] = ([{
  path: '/qrcode',
  component: qrCode,
  name: 'qrcode',
  meta: {
    title: '行程预览'
  }
}, {
  path: '/qrcode/preview',
  component: preview,
  name: 'preview',
  meta: {
    title: '行程预览'
  }
}]);

/***/ }),

/***/ "1+9y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2bkc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// 客户管理

/* harmony default export */ __webpack_exports__["default"] = ([
// 联系人级
{
  path: '/customer/contact',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(53)]).then(__webpack_require__.bind(null, "wuxr"));
  },
  meta: {
    title: '万众国旅'
  }
}, {
  path: '/customer/contact/audit',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(65)]).then(__webpack_require__.bind(null, "y4z4"));
  },
  meta: {
    title: '万众国旅'
  }
}, {
  path: '/customer/contact/edit',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(27)]).then(__webpack_require__.bind(null, "vmrA"));
  },
  meta: {
    title: '万众国旅'
  }
}, {
  path: '/customer/contact/detail',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(60)]).then(__webpack_require__.bind(null, "7VcV"));
  },
  meta: {
    title: '万众国旅'
  }
},
// 营业部级
{
  path: '/customer/operate',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(62)]).then(__webpack_require__.bind(null, "uUXD"));
  },
  meta: {
    title: '万众国旅'
  }
}, {
  path: '/customer/operate/edit',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(29)]).then(__webpack_require__.bind(null, "wSoT"));
  },
  meta: {
    title: '万众国旅'
  }
}, {
  path: '/customer/operate/audit',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(63)]).then(__webpack_require__.bind(null, "kkOn"));
  },
  meta: {
    title: '万众国旅'
  }
}, {
  path: '/customer/operate/detail',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(59)]).then(__webpack_require__.bind(null, "+Ebh"));
  },
  meta: {
    title: '万众国旅'
  }
},
// 公司级
{
  path: '/customer/company',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(64)]).then(__webpack_require__.bind(null, "X/LM"));
  },
  meta: {
    title: '万众国旅'
  }
}, {
  path: '/customer/company/edit',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(47)]).then(__webpack_require__.bind(null, "6eeM"));
  },
  meta: {
    title: '万众国旅'
  }
}, {
  path: '/customer/company/audit',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(67)]).then(__webpack_require__.bind(null, "qGP+"));
  },
  meta: {
    title: '万众国旅'
  }
}, {
  path: '/customer/company/detail',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(66)]).then(__webpack_require__.bind(null, "QQqh"));
  },
  meta: {
    title: '万众国旅'
  }
}]);

/***/ }),

/***/ "5s8g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6N2g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "91OA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// 订单
var OrderDetail = function OrderDetail() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(41)]).then(__webpack_require__.bind(null, "Dw3n"));
};
var OrderConfirm = function OrderConfirm() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(45)]).then(__webpack_require__.bind(null, "g9Yr"));
};
var OrderReturn = function OrderReturn() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(__webpack_require__.bind(null, "ZW8Z"));
};
var OrderLog = function OrderLog() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(44)]).then(__webpack_require__.bind(null, "kLcY"));
};
var PayResult = function PayResult() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(28)]).then(__webpack_require__.bind(null, "x+um"));
};

/* harmony default export */ __webpack_exports__["default"] = ([{
  path: '/order/detail',
  component: OrderDetail,
  meta: {
    title: '订单详情'
  }
}, {
  path: '/order/confirm',
  component: OrderConfirm,
  meta: {
    title: '订单确认'
  }
}, {
  path: '/order/return',
  component: OrderReturn,
  meta: {
    title: '退团订单'
  }
}, {
  path: '/order/log',
  component: OrderLog,
  meta: {
    title: '订单记录'
  }
}, {
  path: '/order/payresult',
  component: PayResult,
  meta: {
    title: '支付结果'
  }
}]);

/***/ }),

/***/ "9v29":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// 与pc关联的页面
var Bill = function Bill() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, "R/RA"));
};

/* harmony default export */ __webpack_exports__["default"] = ([{
  path: '/pc/bill',
  component: Bill,
  meta: {
    title: '对账收款单'
  }
}]);

/***/ }),

/***/ "A/Zu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// 游客名单

/* harmony default export */ __webpack_exports__["default"] = ([{
  path: '/tourist',
  redirect: '/tourist/name'
}, {
  path: '/tourist/name',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(32)]).then(__webpack_require__.bind(null, "Nf9c"));
  },
  meta: {
    title: '游客名单'
  }
}, {
  path: '/tourist/order',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(71)]).then(__webpack_require__.bind(null, "N0EQ"));
  },
  meta: {
    title: '上传名单'
  }
}, {
  path: '/tourist/edit',
  component: function component() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(24)]).then(__webpack_require__.bind(null, "ejh9"));
  },
  meta: {
    title: '编辑名单'
  }
}]);

/***/ }),

/***/ "Dv74":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// 万众知识库
var Dm = function Dm() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(__webpack_require__.bind(null, "fhSR"));
};

/* harmony default export */ __webpack_exports__["default"] = ([{
  path: '/dm',
  component: Dm,
  name: 'dm',
  meta: {
    title: 'DM单张',
    keepAlive: true
  }
}]);

/***/ }),

/***/ "EHkk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I8/9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ISTF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JQaF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// 逸游高品需求
var Customize = function Customize() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "bFzj"));
};

/* harmony default export */ __webpack_exports__["default"] = ([{
  path: '/eu',
  redirect: '/eu/customize'
}, {
  path: '/eu/customize',
  component: Customize,
  meta: {
    title: '为您定制'
  }
}]);

/***/ }),

/***/ "KWv7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var files = __webpack_require__("RiIY");
var router = [];

files.keys().forEach(function (key) {
  if (key === './index.js' || key === './routes.js') return;
  router = router.concat(files(key).default);
});

// routes
/* harmony default export */ __webpack_exports__["default"] = (router);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/_babel-polyfill@6.26.0@babel-polyfill/lib/index.js
var lib = __webpack_require__("briU");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/_vue@2.6.11@vue/dist/vue.esm.js
var vue_esm = __webpack_require__("kV13");

// EXTERNAL MODULE: ./node_modules/_kkt-domain@1.1.6@kkt-domain/dist/kkt-domain.js
var kkt_domain = __webpack_require__("uraL");
var kkt_domain_default = /*#__PURE__*/__webpack_require__.n(kkt_domain);

// CONCATENATED MODULE: ./src/utils/index.js



// use
vue_esm["default"].use(kkt_domain_default.a);

/*
* 注册全局时间过滤器
 */
vue_esm["default"].filter('dateFilter', function (val) {
  if (val) {
    return val.split('-').splice(1).join('/');
  } else {
    return null;
  }
});
// EXTERNAL MODULE: ./src/prototype/Math.js
var prototype_Math = __webpack_require__("YjF/");
var Math_default = /*#__PURE__*/__webpack_require__.n(prototype_Math);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("IHPB");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/_fecha@2.3.3@fecha/fecha.js
var fecha = __webpack_require__("CdS8");
var fecha_default = /*#__PURE__*/__webpack_require__.n(fecha);

// CONCATENATED MODULE: ./src/prototype/Date.js



/*
* 字符串日期处理
* @param {String}
* @return {Date} Date对象
*/

Date.formatString = function (string) {
  var str = string.replace(/[-|\/|\s|:]/g, ',');
  var dateArr = str.split(',');
  dateArr[1] = dateArr[1] - 1;
  return new (Function.prototype.bind.apply(Date, [null].concat(toConsumableArray_default()(dateArr))))();
};

/*
* 日期格式化
* @param {[String, Date]}
* @return {String}
*/
Date.format = function () {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';

  var dateObj = date;
  if (typeof date === 'string') {
    dateObj = Date.formatString(date);
  }
  return fecha_default.a.format(dateObj, format);
};
// CONCATENATED MODULE: ./src/prototype/index.js


// EXTERNAL MODULE: ./node_modules/_muse-ui@2.1.0@muse-ui/dist/muse-ui.css
var muse_ui = __webpack_require__("5s8g");
var muse_ui_default = /*#__PURE__*/__webpack_require__.n(muse_ui);

// EXTERNAL MODULE: ./node_modules/_muse-ui@2.1.0@muse-ui/dist/theme-light.css
var theme_light = __webpack_require__("OWjY");
var theme_light_default = /*#__PURE__*/__webpack_require__.n(theme_light);

// EXTERNAL MODULE: ./node_modules/_oocss-utils@0.3.0@oocss-utils/utils.css
var utils = __webpack_require__("ISTF");
var utils_default = /*#__PURE__*/__webpack_require__.n(utils);

// EXTERNAL MODULE: ./src/assets/css/index.css
var css = __webpack_require__("n4oI");
var css_default = /*#__PURE__*/__webpack_require__.n(css);

// EXTERNAL MODULE: ./node_modules/_muse-ui@2.1.0@muse-ui/dist/muse-ui.js
var dist_muse_ui = __webpack_require__("q2H9");
var dist_muse_ui_default = /*#__PURE__*/__webpack_require__.n(dist_muse_ui);

// CONCATENATED MODULE: ./src/components/mixins/MuDatePicker.vue
function injectStyle (ssrContext) {
  __webpack_require__("1+9y")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */
var __vue_script__ = null
/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var MuDatePicker = (Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/mixins/BackTop.vue
//

/* harmony default export */ var BackTop = ({
  mounted: function mounted() {
    window.addEventListener('scroll', this.scrollListener, true);
    window.addEventListener('resize', this.scrollListener, true);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll, true);
    window.removeEventListener('resize', this.handleScroll, true);
  }
});
// CONCATENATED MODULE: ./src/components/mixins/BackTop.vue
var BackTop_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */
var BackTop___vue_template__ = null
/* template functional */
var BackTop___vue_template_functional__ = false
/* styles */
var BackTop___vue_styles__ = null
/* scopeId */
var BackTop___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var BackTop___vue_module_identifier__ = null
var BackTop_Component = BackTop_normalizeComponent(
  BackTop,
  BackTop___vue_template__,
  BackTop___vue_template_functional__,
  BackTop___vue_styles__,
  BackTop___vue_scopeId__,
  BackTop___vue_module_identifier__
)

/* harmony default export */ var mixins_BackTop = (BackTop_Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/mixins/MuRadio.vue

/* harmony default export */ var MuRadio = ({
  name: 'mu-radio',
  props: {
    value: {
      type: [Number, String]
    },
    nativeValue: {
      type: [Number, String]
    }
  }
});
// CONCATENATED MODULE: ./src/components/mixins/MuRadio.vue
var MuRadio_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */
var MuRadio___vue_template__ = null
/* template functional */
var MuRadio___vue_template_functional__ = false
/* styles */
var MuRadio___vue_styles__ = null
/* scopeId */
var MuRadio___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MuRadio___vue_module_identifier__ = null
var MuRadio_Component = MuRadio_normalizeComponent(
  MuRadio,
  MuRadio___vue_template__,
  MuRadio___vue_template_functional__,
  MuRadio___vue_styles__,
  MuRadio___vue_scopeId__,
  MuRadio___vue_module_identifier__
)

/* harmony default export */ var mixins_MuRadio = (MuRadio_Component.exports);

// CONCATENATED MODULE: ./src/components/mixins/index.js







// 引用 MuseUI
vue_esm["default"].use(dist_muse_ui_default.a);





mixins({
	'mu-date-picker': MuDatePicker,
	'mu-back-top': mixins_BackTop,
	'mu-radio': mixins_MuRadio
});

function mixins(mixinsObj) {
	for (var key in mixinsObj) {
		vue_esm["default"].component(key).mixin(mixinsObj[key]);
	}
}
// EXTERNAL MODULE: ./node_modules/_vue2-toast@1.3.2@vue2-toast/lib/index.js
var _vue2_toast_1_3_2_vue2_toast_lib = __webpack_require__("TPfW");
var _vue2_toast_1_3_2_vue2_toast_lib_default = /*#__PURE__*/__webpack_require__.n(_vue2_toast_1_3_2_vue2_toast_lib);

// EXTERNAL MODULE: ./node_modules/_vue2-toast@1.3.2@vue2-toast/lib/toast.css
var toast = __webpack_require__("I8/9");
var toast_default = /*#__PURE__*/__webpack_require__.n(toast);

// EXTERNAL MODULE: ./node_modules/_alloyfinger@0.1.16@alloyfinger/alloy_finger.js
var alloy_finger = __webpack_require__("rH/g");
var alloy_finger_default = /*#__PURE__*/__webpack_require__.n(alloy_finger);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/KktGesture.vue
//
//
//
//
//
//
//


/* harmony default export */ var KktGesture = ({
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var _this = this;
    var af = new alloy_finger_default.a(this.$refs.wrap, {});
    af.on('swipe', function (e) {
      // direction: Left or Right
      _this.$emit('swipe', e.direction, e);
    }), af.on('touchMove', function (e) {
      _this.$emit('touchMove', e);
    }), af.on('touchEnd', function (e) {
      _this.$emit('touchEnd', e);
    });
    af.on('doubleTap', function (e) {
      _this.$emit('doubleTap', e);
    });
    af.on('pinch', function (e) {
      _this.$emit('pinch', e);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-00d094bb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/KktGesture.vue
var KktGesture_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrap"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: KktGesture_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_KktGesture = (esExports);
// CONCATENATED MODULE: ./src/components/KktGesture.vue
function KktGesture_injectStyle (ssrContext) {
  __webpack_require__("Qmbi")
}
var KktGesture_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var KktGesture___vue_template_functional__ = false
/* styles */
var KktGesture___vue_styles__ = KktGesture_injectStyle
/* scopeId */
var KktGesture___vue_scopeId__ = "data-v-00d094bb"
/* moduleIdentifier (server only) */
var KktGesture___vue_module_identifier__ = null
var KktGesture_Component = KktGesture_normalizeComponent(
  KktGesture,
  components_KktGesture,
  KktGesture___vue_template_functional__,
  KktGesture___vue_styles__,
  KktGesture___vue_scopeId__,
  KktGesture___vue_module_identifier__
)

/* harmony default export */ var src_components_KktGesture = (KktGesture_Component.exports);

// EXTERNAL MODULE: ./node_modules/_lodash@4.17.19@lodash/lodash.js
var lodash = __webpack_require__("ctG6");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/KktDatePicker.vue
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var KktDatePicker = ({
  props: {
    value: {
      type: String,
      default: Date.format()
    },
    // 开始时间
    startDate: {
      type: [String, Date],
      default: function _default() {
        return new Date(0);
      }
    },
    // 结束时间
    endDate: {
      type: [String, Date],
      default: function _default() {
        return new Date();
      }
    },
    // 禁止显示月份
    disableM: {
      type: Boolean,
      default: false
    },
    // 禁止显示天数
    disableD: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      open: false,
      slots: [],
      dateValues: [],
      currentValues: [],
      years: [],
      days: [],
      currentMonthes: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      monthes: [],
      start: null,
      end: null
    };
  },


  computed: {
    dateSlots: function dateSlots() {
      var arr = [{
        width: '100%',
        textAlign: 'center',
        values: lodash_default.a.cloneDeep(this.years)
      }];
      if (!this.disableM) {
        arr.push({
          width: '100%',
          textAlign: 'center',
          values: lodash_default.a.cloneDeep(this.monthes)
        });
        if (!this.disableD) {
          arr.push({
            width: '100%',
            textAlign: 'center',
            values: lodash_default.a.cloneDeep(this.days)
          });
        }
      }
      return arr;
    }
  },

  created: function created() {
    var _this = this;

    this.start = this.startDate;
    this.end = this.endDate;
    // 兼容Safari浏览器
    if (typeof this.start === 'string') {
      this.start = Date.formatString(this.start);
    }
    if (typeof this.end === 'string') {
      this.start = Date.formatString(this.end);
    }
    // 初始化需要显示的日期
    this.initValue(this.value);
    // 获取年份
    this.years = Array.apply(null, { length: this.end.getFullYear() - this.start.getFullYear() + 1 }).map(function (item, index) {
      return index + _this.start.getFullYear() + '';
    }).reverse();
    var date = new Date(parseInt(this.currentValues[0]), parseInt(this.currentValues[1]), 0);
    // 获取月份
    if (!this.disableM || !this.disableD) {
      this.getMonthes();
      this.getDays();
    }
  },


  watch: {
    value: function value(val) {
      this.initValue(val);
    },
    years: function years(val, oldVal) {
      this.renderData(val, oldVal);
    },
    monthes: function monthes(val, oldVal) {
      this.renderData(val, oldVal);
    },
    days: function days(val, oldVal) {
      this.renderData(val, oldVal);
    }
  },

  methods: {
    initValue: function initValue(val) {
      this.dateValues = Date.format(val).split('-');
      this.currentValues = lodash_default.a.cloneDeep(this.dateValues);
    },
    show: function show() {
      this.open = true;
    },
    close: function close() {
      this.open = false;
    },
    sure: function sure() {
      var data = this.dateValues.join('-');
      if (this.disableM) {
        data = this.dateValues[0];
      } else {
        if (this.disableD) {
          data = [this.dateValues[0], this.dateValues[1]].join('-');
        }
      }
      this.open = false;
      this.$emit('on-change', data);
    },


    /*
    * 数据重新渲染
    */
    renderData: function renderData(val, oldVal) {
      var _this2 = this;

      var flag = true;
      val.forEach(function (item, index) {
        if (item !== oldVal[index]) flag = false;
      });
      if (val.length !== oldVal.length) flag = false;
      if (flag === false) {
        this.slots = [];
        this.$nextTick(function () {
          _this2.slots = lodash_default.a.cloneDeep(_this2.dateSlots);
        });
      }
    },


    /*
    * 时间选择
    * @param {String, Number} value index(0: 年, 1: 月, 2: 日) 
    */
    dateChange: function dateChange(value, index) {
      this.currentValues[index] = value;
      if (!this.disableM || !this.disableD) {
        this.getMonthes();
        this.getDays();
      }
      this.dateValues = lodash_default.a.cloneDeep(this.currentValues);
    },


    /*
    * 获取当年月份
    */
    getMonthes: function getMonthes() {
      var _this3 = this;

      var monthes = [];
      if (parseInt(this.currentValues[0]) === this.end.getFullYear()) {
        monthes = this.currentMonthes.filter(function (month) {
          return parseInt(month) <= _this3.end.getMonth() + 1;
        });
        if (monthes.indexOf(this.currentValues[1]) === -1) {
          this.currentValues[1] = monthes[monthes.length - 1];
        }
      } else if (parseInt(this.currentValues[0]) === this.start.getFullYear()) {
        monthes = this.currentMonthes.filter(function (month) {
          return parseInt(month) >= _this3.start.getMonth() + 1;
        });
        if (monthes.indexOf(this.currentValues[1]) === -1) {
          this.currentValues[1] = monthes[0];
        }
      } else {
        monthes = lodash_default.a.cloneDeep(this.currentMonthes);
      }
      this.dateValues = lodash_default.a.cloneDeep(this.currentValues);
      this.monthes = monthes;
    },


    /*
    * 获取当月日期
    */
    getDays: function getDays() {
      var _this4 = this;

      var date = new Date(parseInt(this.currentValues[0]), parseInt(this.currentValues[1]), 0);
      var days = Array.apply(null, { length: date.getDate() }).map(function (item, index) {
        return index + 1 < 10 ? '0' + (index + 1) : index + 1 + '';
      });
      if (parseInt(this.currentValues[0]) === this.end.getFullYear() && parseInt(this.currentValues[1]) - 1 === this.end.getMonth()) {
        days = days.filter(function (day) {
          return day <= _this4.end.getDate();
        });
        if (days.indexOf(this.currentValues[2]) === -1) {
          this.currentValues[2] = days[days.length - 1];
        }
      } else if (parseInt(this.currentValues[0]) === this.start.getFullYear() && parseInt(this.currentValues[1]) - 1 === this.start.getMonth()) {
        days = days.filter(function (day) {
          return day >= _this4.start.getDate();
        });
        if (days.indexOf(this.currentValues[2]) === -1) {
          this.currentValues[2] = days[0];
        }
      }
      this.days = days;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-38c7b23e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/KktDatePicker.vue
var KktDatePicker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mu-popup',{staticStyle:{"width":"100%"},attrs:{"position":"bottom","open":_vm.open,"popupClass":"kkt-date-picker"},on:{"close":_vm.close}},[_c('div',{staticStyle:{"text-align":"right","background":"#eff2f7"}},[_c('mu-flat-button',{staticStyle:{"float":"left"},attrs:{"label":"取消","color":'#4594fb'},on:{"click":_vm.close}}),_vm._v(" "),_c('mu-flat-button',{attrs:{"label":"确认","color":'#4594fb'},on:{"click":_vm.sure}})],1),_vm._v(" "),_c('mu-content-block',[_c('mu-picker',{attrs:{"slots":_vm.slots,"visible-item-count":5,"values":_vm.dateValues},on:{"change":_vm.dateChange}})],1)],1)}
var KktDatePicker_staticRenderFns = []
var KktDatePicker_esExports = { render: KktDatePicker_render, staticRenderFns: KktDatePicker_staticRenderFns }
/* harmony default export */ var components_KktDatePicker = (KktDatePicker_esExports);
// CONCATENATED MODULE: ./src/components/KktDatePicker.vue
function KktDatePicker_injectStyle (ssrContext) {
  __webpack_require__("YDQt")
}
var KktDatePicker_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var KktDatePicker___vue_template_functional__ = false
/* styles */
var KktDatePicker___vue_styles__ = KktDatePicker_injectStyle
/* scopeId */
var KktDatePicker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var KktDatePicker___vue_module_identifier__ = null
var KktDatePicker_Component = KktDatePicker_normalizeComponent(
  KktDatePicker,
  components_KktDatePicker,
  KktDatePicker___vue_template_functional__,
  KktDatePicker___vue_styles__,
  KktDatePicker___vue_scopeId__,
  KktDatePicker___vue_module_identifier__
)

/* harmony default export */ var src_components_KktDatePicker = (KktDatePicker_Component.exports);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("a3Yh");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/KktTimeSelect.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var KktTimeSelect = ({
  props: {
    // 禁止秒
    disableS: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    value: {
      type: String,
      default: function _default() {
        return '00:00:00';
      }
    }
  },

  watch: {
    value: function value() {
      this.initDate();
    }
  },

  data: function data() {
    var _ref;

    return _ref = {
      open: false,
      hour: ['00'],
      hourSlots: [{
        width: '100%',
        textAlign: 'center',
        values: Array.apply(null, { length: 24 }).map(function (item, index) {
          return index > 9 ? index : '0' + index;
        })
      }],
      slots: [{
        width: '100%',
        textAlign: 'center',
        values: Array.apply(null, { length: 60 }).map(function (item, index) {
          return index > 9 ? index : '0' + index;
        })
      }]
    }, defineProperty_default()(_ref, 'slots', [{
      width: '100%',
      textAlign: 'center',
      values: Array.apply(null, { length: 60 }).map(function (item, index) {
        return index > 9 ? index : '0' + index;
      })
    }]), defineProperty_default()(_ref, 'minute', ['00']), defineProperty_default()(_ref, 'second', ['00']), defineProperty_default()(_ref, 'dateValues', ['00', '00', '00']), _ref;
  },
  created: function created() {
    this.initDate();
  },


  methods: {
    initDate: function initDate() {
      if (this.value) {
        var arr = this.value.split(':');
        this.hour = [arr[0]] || ['00'];
        this.minute = [arr[1]] || ['00'];
        this.second = [arr[2]] || ['00'];
      }
    },
    show: function show() {
      this.open = true;
    },
    close: function close() {
      this.open = false;
    },
    sure: function sure() {
      this.open = false;
      this.$emit('on-change', this.dateValues.join(':'));
    },


    /*
    * 时间选择
    * @param {Number, String}
    */
    dateChange: function dateChange($index, value) {
      this.dateValues[$index] = value;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-2c9289e9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/KktTimeSelect.vue
var KktTimeSelect_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mu-popup',{staticStyle:{"width":"100%"},attrs:{"position":"bottom","open":_vm.open,"popupClass":"kkt-date-picker"},on:{"close":_vm.close}},[_c('div',{staticStyle:{"text-align":"right","background":"#eff2f7"}},[_c('mu-flat-button',{staticStyle:{"float":"left"},attrs:{"label":"取消","color":'#4594fb'},on:{"click":_vm.close}}),_vm._v(" "),_c('mu-flat-button',{attrs:{"label":"确认","color":'#4594fb'},on:{"click":_vm.sure}})],1),_vm._v(" "),_c('mu-content-block',{staticStyle:{"display":"flex"}},[_c('mu-picker',{attrs:{"slots":_vm.hourSlots,"visible-item-count":5,"values":_vm.hour},on:{"change":function($event){return _vm.dateChange(0, $event, $event)}}}),_vm._v(" "),_c('mu-picker',{attrs:{"slots":_vm.slots,"visible-item-count":5,"values":_vm.minute},on:{"change":function($event){return _vm.dateChange(1, $event, $event)}}}),_vm._v(" "),_c('mu-picker',{attrs:{"slots":_vm.slots,"visible-item-count":5,"values":_vm.second},on:{"change":function($event){return _vm.dateChange(2, $event, $event)}}})],1)],1)}
var KktTimeSelect_staticRenderFns = []
var KktTimeSelect_esExports = { render: KktTimeSelect_render, staticRenderFns: KktTimeSelect_staticRenderFns }
/* harmony default export */ var components_KktTimeSelect = (KktTimeSelect_esExports);
// CONCATENATED MODULE: ./src/components/KktTimeSelect.vue
var KktTimeSelect_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var KktTimeSelect___vue_template_functional__ = false
/* styles */
var KktTimeSelect___vue_styles__ = null
/* scopeId */
var KktTimeSelect___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var KktTimeSelect___vue_module_identifier__ = null
var KktTimeSelect_Component = KktTimeSelect_normalizeComponent(
  KktTimeSelect,
  components_KktTimeSelect,
  KktTimeSelect___vue_template_functional__,
  KktTimeSelect___vue_styles__,
  KktTimeSelect___vue_scopeId__,
  KktTimeSelect___vue_module_identifier__
)

/* harmony default export */ var src_components_KktTimeSelect = (KktTimeSelect_Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/NewDatePicker/calendarToolbar.vue
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var calendarToolbar = ({
  props: {
    dateTimeFormat: {
      type: Object
    },
    displayDates: {
      type: Array
    },
    slideType: {
      type: String
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-14eb5d29","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/NewDatePicker/calendarToolbar.vue
var calendarToolbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mu-calendar-toolbar"},[_c('div',{staticClass:"mu-calendar-toolbar-title-wrapper"},_vm._l((_vm.displayDates),function(displayDate,index){return _c('transition',{key:index,attrs:{"name":'mu-calendar-slide-' + _vm.slideType}},[_c('div',{key:displayDate.getTime(),staticClass:"mu-calendar-toolbar-title"},[_vm._v("\n        "+_vm._s(_vm.dateTimeFormat.formatMonth(displayDate))+"\n      ")])])}),1)])}
var calendarToolbar_staticRenderFns = []
var calendarToolbar_esExports = { render: calendarToolbar_render, staticRenderFns: calendarToolbar_staticRenderFns }
/* harmony default export */ var NewDatePicker_calendarToolbar = (calendarToolbar_esExports);
// CONCATENATED MODULE: ./src/components/NewDatePicker/calendarToolbar.vue
var calendarToolbar_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var calendarToolbar___vue_template_functional__ = false
/* styles */
var calendarToolbar___vue_styles__ = null
/* scopeId */
var calendarToolbar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var calendarToolbar___vue_module_identifier__ = null
var calendarToolbar_Component = calendarToolbar_normalizeComponent(
  calendarToolbar,
  NewDatePicker_calendarToolbar,
  calendarToolbar___vue_template_functional__,
  calendarToolbar___vue_styles__,
  calendarToolbar___vue_scopeId__,
  calendarToolbar___vue_module_identifier__
)

/* harmony default export */ var components_NewDatePicker_calendarToolbar = (calendarToolbar_Component.exports);

// CONCATENATED MODULE: ./src/components/NewDatePicker/utils.js
function isPc() {
  var uaInfo = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  var agents = ['Android', 'iPhone', 'Windows Phone', 'iPad', 'iPod'];
  var flag = true;
  for (var i = 0; i < agents.length; i++) {
    if (uaInfo.indexOf(agents[i]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/NewDatePicker/dayButton.vue


/* harmony default export */ var dayButton = ({
  props: {
    selected: {
      type: Boolean,
      default: false
    },
    date: {
      type: Date
    },
    disabled: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      hover: false
    };
  },

  computed: {
    isNow: function isNow() {
      var now = new Date();
      return this.date && this.date.getYear() === now.getYear() && this.date.getMonth() === now.getMonth() && this.date.getDate() === now.getDate();
    },
    dayButtonClass: function dayButtonClass() {
      return {
        selected: false,
        hover: this.hover,
        'mu-day-button': true,
        disabled: this.disabled,
        now: this.isNow,
        'mu-day-multiple-button': true,
        'mu-day-selected-button': this.text
      };
    }
  },
  methods: {
    handleHover: function handleHover() {
      if (isPc() && !this.disabled) this.hover = true;
    },
    handleHoverExit: function handleHoverExit() {
      this.hover = false;
    },
    handleClick: function handleClick(event) {
      this.$emit('click', event);
    }
  },
  render: function render(h) {
    var array = [];
    if (this.text) {
      array = this.text.split('/').map(function (item) {
        return h('span', {
          class: 'mu-day-button-multiple-text',
          domProps: {
            innerHTML: item
          }
        });
      });
    }
    return this.date ? h('button', {
      class: this.dayButtonClass,
      on: {
        mouseenter: this.handleHover,
        mouseleave: this.handleHoverExit,
        click: this.handleClick
      },
      domProps: {
        disabled: this.disabled
      }
    }, [h('div', { class: 'mu-day-button-bg' }), h('span', {
      class: 'mu-day-button-text',
      domProps: {
        innerHTML: this.date.getDate()
      }
    }), h('span', {
      class: 'mu-day-button-multiple'
    }, array)]) : h('span', { class: 'mu-day-empty' });
  }
});
// CONCATENATED MODULE: ./src/components/NewDatePicker/dayButton.vue
function dayButton_injectStyle (ssrContext) {
  __webpack_require__("EHkk")
}
var dayButton_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */
var dayButton___vue_template__ = null
/* template functional */
var dayButton___vue_template_functional__ = false
/* styles */
var dayButton___vue_styles__ = dayButton_injectStyle
/* scopeId */
var dayButton___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var dayButton___vue_module_identifier__ = null
var dayButton_Component = dayButton_normalizeComponent(
  dayButton,
  dayButton___vue_template__,
  dayButton___vue_template_functional__,
  dayButton___vue_styles__,
  dayButton___vue_scopeId__,
  dayButton___vue_module_identifier__
)

/* harmony default export */ var NewDatePicker_dayButton = (dayButton_Component.exports);

// CONCATENATED MODULE: ./src/components/NewDatePicker/dateUtils.js
/**
 * material-ui dateUtils.js
 * https://github.com/callemall/material-ui/blob/master/src/DatePicker/dateUtils.js
 */
var localConfig = {
  dayAbbreviation: ['日', '一', '二', '三', '四', '五', '六'],
  dayList: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
  monthList: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
  monthLongList: ['1 月', '2 月', '3 月', '4 月', '5 月', '6 月', '7 月', '8 月', '9 月', '10 月', '11 月', '12 月']
};

var dateTimeFormat = {
  formatDisplay: function formatDisplay(date) {
    var day = date.getDate();
    return localConfig.monthList[date.getMonth()] + '-' + (day > 9 ? day : '0' + day) + ' ' + localConfig.dayList[date.getDay()];
  },
  formatMonth: function formatMonth(date) {
    return date.getFullYear() + ' \u5E74 ' + localConfig.monthLongList[date.getMonth()];
  },
  getWeekDayArray: function getWeekDayArray(firstDayOfWeek) {
    var beforeArray = [];
    var afterArray = [];
    var dayAbbreviation = localConfig.dayAbbreviation;
    for (var i = 0; i < dayAbbreviation.length; i++) {
      if (i < firstDayOfWeek) {
        afterArray.push(dayAbbreviation[i]);
      } else {
        beforeArray.push(dayAbbreviation[i]);
      }
    }
    return beforeArray.concat(afterArray);
  }
};

function getDaysInMonth(d) {
  var resultDate = getFirstDayOfMonth(d);

  resultDate.setMonth(resultDate.getMonth() + 1);
  resultDate.setDate(resultDate.getDate() - 1);

  return resultDate.getDate();
}

function getFirstDayOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1);
}

function getWeekArray(d, firstDayOfWeek) {
  var dayArray = [];
  var daysInMonth = getDaysInMonth(d);
  var weekArray = [];
  var week = [];

  for (var i = 1; i <= daysInMonth; i++) {
    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i));
  }

  var addWeek = function addWeek(week) {
    var emptyDays = 7 - week.length;
    for (var _i = 0; _i < emptyDays; ++_i) {
      week[weekArray.length ? 'push' : 'unshift'](null);
    }
    weekArray.push(week);
  };

  dayArray.forEach(function (day) {
    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
      addWeek(week);
      week = [];
    }
    week.push(day);
    if (dayArray.indexOf(day) === dayArray.length - 1) {
      addWeek(week);
    }
  });

  return weekArray;
}

function cloneDate(d) {
  return new Date(d.getTime());
}

function isEqualDate(d1, d2) {
  return d1 && d2 && d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
}

function monthDiff(d1, d2) {
  var m = void 0;
  m = (d1.getFullYear() - d2.getFullYear()) * 12;
  m += d1.getMonth();
  m -= d2.getMonth();
  return m;
}
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/NewDatePicker/calendarMonth.vue
//
//
//
//
//
//
//
//



/* harmony default export */ var calendarMonth = ({
  props: {
    displayDate: {
      type: Date
    },
    firstDayOfWeek: {
      type: Number,
      default: 1
    },
    selectedDate: {
      type: Date
    },
    multiple: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var _this = this;

    var weeksArray = getWeekArray(this.displayDate || new Date(), this.firstDayOfWeek);
    weeksArray = weeksArray.map(function (item) {
      return item.map(function (day) {
        var array = _this.multiple.filter(function (o) {
          o.date.valueOf() === (day ? day.valueOf() : 0);
          if (!day) return false;
          if (o.date.getFullYear() === day.getFullYear() && o.date.getMonth() === day.getMonth() && o.date.getDate() === day.getDate()) return true;
        });
        if (array.length) {
          return array[0];
        } else {
          return {
            date: day,
            text: null
          };
        }
      });
    });
    return {
      weeksArray: weeksArray
    };
  },

  methods: {
    equalsDate: function equalsDate(date) {
      return isEqualDate(date, new Date());
    },
    handleClick: function handleClick(date) {
      if (date) this.$emit('selected', date);
    }
  },
  components: {
    'day-button': NewDatePicker_dayButton
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-f4f83ac0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/NewDatePicker/calendarMonth.vue
var calendarMonth_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mu-calendar-monthday-content",staticStyle:{"height":"260px"}},_vm._l((_vm.weeksArray),function(week,i){return _c('div',{key:i,staticClass:"mu-calendar-monthday-row",staticStyle:{"height":"50px"}},_vm._l((week),function(item,j){return _c('day-button',{key:'dayButton' + i + '' + j,attrs:{"selected":_vm.equalsDate(item.date),"date":item.date,"text":item.text},on:{"click":function($event){return _vm.handleClick(item)}}})}),1)}),0)}
var calendarMonth_staticRenderFns = []
var calendarMonth_esExports = { render: calendarMonth_render, staticRenderFns: calendarMonth_staticRenderFns }
/* harmony default export */ var NewDatePicker_calendarMonth = (calendarMonth_esExports);
// CONCATENATED MODULE: ./src/components/NewDatePicker/calendarMonth.vue
var calendarMonth_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var calendarMonth___vue_template_functional__ = false
/* styles */
var calendarMonth___vue_styles__ = null
/* scopeId */
var calendarMonth___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var calendarMonth___vue_module_identifier__ = null
var calendarMonth_Component = calendarMonth_normalizeComponent(
  calendarMonth,
  NewDatePicker_calendarMonth,
  calendarMonth___vue_template_functional__,
  calendarMonth___vue_styles__,
  calendarMonth___vue_scopeId__,
  calendarMonth___vue_module_identifier__
)

/* harmony default export */ var components_NewDatePicker_calendarMonth = (calendarMonth_Component.exports);

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/NewDatePicker/calendar.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var calendar = ({
  props: {
    dateTimeFormat: {
      type: Object,
      default: function _default() {
        return dateTimeFormat;
      }
    },
    firstDayOfWeek: {
      type: Number,
      default: 1
    },
    initialDate: {
      type: Date,
      default: function _default() {
        return new Date();
      }
    },
    multiple: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var displayDate = cloneDate(this.initialDate);
    displayDate.setDate(1);
    return {
      weekTexts: this.dateTimeFormat.getWeekDayArray(this.firstDayOfWeek),
      displayDates: [displayDate],
      selectedDate: this.initialDate,
      slideType: 'next'
    };
  },

  methods: {
    handleSelected: function handleSelected(date) {
      this.$emit('selected', date);
    }
  },
  watch: {
    initialDate: function initialDate(val) {
      this.selectedDate = val;
    }
  },
  components: {
    'calendar-toolbar': components_NewDatePicker_calendarToolbar,
    'calendar-month': components_NewDatePicker_calendarMonth
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-2355619a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/NewDatePicker/calendar.vue
var calendar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mu-calendar"},[_c('div',{staticClass:"mu-calendar-container"},[_c('div',{staticClass:"mu-calendar-monthday-container"},[_c('calendar-toolbar',{attrs:{"slideType":_vm.slideType,"displayDates":_vm.displayDates,"dateTimeFormat":_vm.dateTimeFormat}}),_vm._v(" "),_c('div',{staticClass:"mu-calendar-week"},_vm._l((_vm.weekTexts),function(weekText,index){return _c('span',{key:index,staticClass:"mu-calendar-week-day"},[_vm._v(_vm._s(weekText))])}),0),_vm._v(" "),_c('div',{staticClass:"mu-calendar-monthday",staticStyle:{"height":"260px"}},_vm._l((_vm.displayDates),function(displayDate,index){return _c('transition',{key:index,attrs:{"name":'mu-calendar-slide-' + _vm.slideType}},[_c('div',{key:displayDate.getTime(),staticClass:"mu-calendar-monthday-slide"},[_c('calendar-month',{attrs:{"displayDate":displayDate,"firstDayOfWeek":_vm.firstDayOfWeek,"selectedDate":_vm.selectedDate,"multiple":_vm.multiple},on:{"selected":_vm.handleSelected}})],1)])}),1)],1)])])}
var calendar_staticRenderFns = []
var calendar_esExports = { render: calendar_render, staticRenderFns: calendar_staticRenderFns }
/* harmony default export */ var NewDatePicker_calendar = (calendar_esExports);
// CONCATENATED MODULE: ./src/components/NewDatePicker/calendar.vue
function calendar_injectStyle (ssrContext) {
  __webpack_require__("XMD6")
}
var calendar_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var calendar___vue_template_functional__ = false
/* styles */
var calendar___vue_styles__ = calendar_injectStyle
/* scopeId */
var calendar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var calendar___vue_module_identifier__ = null
var calendar_Component = calendar_normalizeComponent(
  calendar,
  NewDatePicker_calendar,
  calendar___vue_template_functional__,
  calendar___vue_styles__,
  calendar___vue_scopeId__,
  calendar___vue_module_identifier__
)

/* harmony default export */ var components_NewDatePicker_calendar = (calendar_Component.exports);

// CONCATENATED MODULE: ./src/components/NewDatePicker/index.js

// EXTERNAL MODULE: ./src/components/Modal.vue + 2 modules
var Modal = __webpack_require__("/o5o");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/Page.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Page = ({
  props: {
    title: {
      type: String
    },

    // 是否禁止下拉刷新
    disableRefresh: {
      type: Boolean,
      default: false
    },

    // 是否禁止上拉加载
    disableLoad: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      trigger: null,
      loading: false,
      refreshing: false
    };
  },
  mounted: function mounted() {
    this.trigger = this.$refs.page;
  },


  methods: {
    refresh: function refresh() {
      this.$emit('refresh');
    },
    startRefresh: function startRefresh() {
      this.refreshing = true;
    },
    stopRefresh: function stopRefresh() {
      this.refreshing = false;
    },
    loadMore: function loadMore() {
      this.$emit('load');
    },
    startLoad: function startLoad() {
      this.loading = true;
    },
    stopLoad: function stopLoad() {
      this.loading = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-259e2556","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/Page.vue
var Page_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header"},[_vm._t("header",[_c('mu-appbar',{staticStyle:{"text-align":"center"},attrs:{"title":_vm.title}},[_c('img',{attrs:{"slot":"left","src":__webpack_require__("THzl"),"alt":"","width":"20","height":"20"},on:{"click":function($event){return _vm.$router.back(-1)}},slot:"left"})])])],2),_vm._v(" "),_c('div',{ref:"page",staticClass:"page-wrap"},[(!_vm.disableRefresh)?_c('mu-refresh-control',{attrs:{"refreshing":_vm.refreshing,"trigger":_vm.trigger},on:{"refresh":_vm.refresh}}):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),(!_vm.disableLoad)?_c('mu-infinite-scroll',{attrs:{"scroller":_vm.trigger,"loading":_vm.loading},on:{"load":_vm.loadMore}}):_vm._e()],2)])}
var Page_staticRenderFns = []
var Page_esExports = { render: Page_render, staticRenderFns: Page_staticRenderFns }
/* harmony default export */ var components_Page = (Page_esExports);
// CONCATENATED MODULE: ./src/components/Page.vue
function Page_injectStyle (ssrContext) {
  __webpack_require__("Qn5z")
}
var Page_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var Page___vue_template_functional__ = false
/* styles */
var Page___vue_styles__ = Page_injectStyle
/* scopeId */
var Page___vue_scopeId__ = "data-v-259e2556"
/* moduleIdentifier (server only) */
var Page___vue_module_identifier__ = null
var Page_Component = Page_normalizeComponent(
  Page,
  components_Page,
  Page___vue_template_functional__,
  Page___vue_styles__,
  Page___vue_scopeId__,
  Page___vue_module_identifier__
)

/* harmony default export */ var src_components_Page = (Page_Component.exports);

// CONCATENATED MODULE: ./src/components/directives/rebound.js
/*
* 修复ios页面不回弹问题
*/

var scrollY = window.scrollY;
var timer = null;
var isIos = /iPhone|iPad|iPod/.test(navigator.userAgent);

function checkInput(dom) {
  return dom.tagName.toLowerCase() === 'input' && (dom.type === 'text' || dom.type === 'textarea' || dom.type === 'password');
}

function focusIn(e) {
  if (checkInput(e.target)) {
    scrollY = window.scrollY;
    if (timer) clearTimeout(timer);
  }
}

function focusOut(e) {
  if (checkInput(e.target)) {
    timer = setTimeout(function () {
      window.scrollTo(0, scrollY);
    });
  }
}

function bind(el, binding) {
  if (!isIos) return;
  window.addEventListener('focusin', focusIn);
  window.addEventListener('focusout', focusOut);
}

function unbind(el, binding) {
  if (!isIos) return;
  window.removeEventListener('focusin', focusIn);
  window.removeEventListener('focusout', focusOut);
}

/* harmony default export */ var rebound = ({
  bind: bind,
  unbind: unbind,
  update: function update(el, binding) {
    if (binding.value === undefined) return;
    if (binding.value) {
      bind(el, binding);
    } else {
      unbind(el, binding);
    }
  }
});
// CONCATENATED MODULE: ./src/components/index.js

// 基础UI组件库

// 第三方组件库


// 自定义组件库



// 注册自定义组件





// 自定义指令


var mixinObj = {
  'NewDatePicker': components_NewDatePicker_calendar,
  'KktGesture': src_components_KktGesture,
  'KktDatePicker': src_components_KktDatePicker,
  'KktTimeSelect': src_components_KktTimeSelect,
  'Modal': Modal["a" /* default */],
  'Page': src_components_Page
};

for (var components_key in mixinObj) {
  vue_esm["default"].component(components_key, mixinObj[components_key]);
}

// 注册第三方组件库
vue_esm["default"].use(_vue2_toast_1_3_2_vue2_toast_lib_default.a, {
  defaultType: 'center',
  duration: 2000,
  wordWrap: true,
  width: '150px'
});

// 注册自定义指令
vue_esm["default"].directive('rebound', rebound);
// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("4YfN");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/_vuex@2.5.0@vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("HVJf");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var App = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('keepAlive', ['excludeName']))
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-f893843c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"app-main"},[_c('keep-alive',{attrs:{"exclude":_vm.excludeName}},[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),_vm._v(" "),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e(),_vm._v(" "),(!(_vm.$route.meta.ignoreBackTop === true))?_c('mu-back-top',{attrs:{"height":100,"bottom":80,"right":30,"duration":1000}}):_vm._e()],1)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("XgS3")
}
var App_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./src/router/index.js
var router = __webpack_require__("YaEn");

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("lC5x");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("J0Oq");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./src/api/exposure.js
var exposure = __webpack_require__("hpad");

// CONCATENATED MODULE: ./src/store/modules/userInfo.js




/* harmony default export */ var userInfo = ({
	namespaced: true,
	state: {
		userInfo: {}
	},
	getters: {
		userInfo: function userInfo(state) {
			return state.userInfo;
		}
	},
	mutations: {
		SET_USERINFO: function SET_USERINFO(state, data) {
			state.userInfo = data.data;
		}
	},
	actions: {
		getCurrentUserInfo: function getCurrentUserInfo(_ref) {
			var _this = this;

			var commit = _ref.commit;
			return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
				return regenerator_default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.t0 = commit;
								_context.next = 3;
								return Object(exposure["c" /* getCurrentUserInfo */])();

							case 3:
								_context.t1 = _context.sent;
								(0, _context.t0)('SET_USERINFO', _context.t1);

							case 5:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		}
	}
});
// CONCATENATED MODULE: ./src/store/modules/keepAlive.js
/* harmony default export */ var keepAlive = ({
  namespaced: true,
  state: {
    // 清除keep-alive的指定的组件的缓存
    excludeName: []
  },
  getters: {
    excludeName: function excludeName(state) {
      return state.excludeName;
    }
  },
  mutations: {
    Set_Exclude_Name: function Set_Exclude_Name(state, data) {
      state.excludeName = data;
    }
  },
  actions: {
    // 设置要清除的组件缓存
    setExcludeName: function setExcludeName(_ref, params) {
      var commit = _ref.commit;

      commit('Set_Exclude_Name', params);
    }
  }
});
// CONCATENATED MODULE: ./src/store/index.js





vue_esm["default"].use(vuex_esm["a" /* default */]);

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
	// strict: process.env.NODE_ENV !== 'production',
	// 模块
	modules: {
		userInfo: userInfo,
		keepAlive: keepAlive
	}
}));
// EXTERNAL MODULE: ./src/assets/fonts/iconfont.css
var iconfont = __webpack_require__("UfKn");
var iconfont_default = /*#__PURE__*/__webpack_require__.n(iconfont);

// CONCATENATED MODULE: ./src/main.js










// import vConsole from 'vconsole'
// new vConsole()

// 请求用户信息
store.dispatch('userInfo/getCurrentUserInfo');

// create app
var app = new vue_esm["default"]({
  el: '#app',
  store: store,
  router: router["default"],
  render: function render(h) {
    return h(src_App);
  }
});

window.Vue = vue_esm["default"];
window.$app = app;

/* harmony default export */ var main = __webpack_exports__["default"] = (app);

/***/ }),

/***/ "OWjY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qmbi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qn5z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RiIY":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./customer.js": "2bkc",
	"./demo.js": "e0oC",
	"./dm.js": "Dv74",
	"./eu.js": "JQaF",
	"./exposure.js": "ssSo",
	"./home.js": "roEk",
	"./index.js": "YaEn",
	"./order.js": "91OA",
	"./pc.js": "9v29",
	"./productDatabase.js": "ooxf",
	"./promotion.js": "ZCgo",
	"./qrCode.js": "0MKX",
	"./routes.js": "KWv7",
	"./school.js": "kvU+",
	"./task.js": "k2xk",
	"./tourist.js": "A/Zu",
	"./user.js": "jnTS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "RiIY";

/***/ }),

/***/ "THzl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-arrow-left.201fa80.svg";

/***/ }),

/***/ "UfKn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vo7i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/promise.js
var promise = __webpack_require__("rVsN");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/_qs@6.9.4@qs/lib/index.js
var lib = __webpack_require__("TCmZ");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/_axios@0.16.2@axios/index.js
var _axios_0_16_2_axios = __webpack_require__("BMa3");
var _axios_0_16_2_axios_default = /*#__PURE__*/__webpack_require__.n(_axios_0_16_2_axios);

// EXTERNAL MODULE: ./node_modules/_vue@2.6.11@vue/dist/vue.esm.js
var vue_esm = __webpack_require__("kV13");

// CONCATENATED MODULE: ./src/utils/whiteList.js
/**
 * 路由白名单，只要是这里设置的不登陆也不会跳转到登陆页面,在fetch.js里面调用
 */
/* harmony default export */ var whiteList = (['/', '/home', '/user/login', '/eu', '/eu/customize', '/pc', '/pc/bill', '/user/register', '/promotion', '/school/knowledge/artdetail', '/qrcode/preview', '/school/training', '/school/training/detail']);
// CONCATENATED MODULE: ./src/utils/fetch.js






// 创建自定义接口服务实例
var service = _axios_0_16_2_axios_default.a.create({
  baseURL: vue_esm["default"].prototype.$dm.get(),
  withCredentials: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-Requested-With': 'XMLHttpRequest'
  },
  transformRequest: [function (data) {
    return lib_default.a.stringify(data);
  }]
});

// 响应中间件
service.interceptors.response.use(function (response) {
  if (response.data.code) {
    response.data.code = parseInt(response.data.code);
  }
  switch (response.data.code) {
    case 3002:
      // 未登录
      if (whiteList.some(function (route) {
        return window.$app.$route.path === route;
      })) {
        return response.data;
      } else {
        var url = encodeURIComponent(location.href);
        location.href = vue_esm["default"].prototype.$dm.get('m') + '/user/login?redirect=' + url;
        return promise_default.a.reject('');
      }
    case 2000:
      // 正常
      return response.data;
    default:
      // 业务错误
      return promise_default.a.reject(response.data.msg);
  }
}, function () {
  vue_esm["default"].prototype.$toast('网络异常，请稍后再试');
  return promise_default.a.reject('');
});

// 接口测试用
window.$http = service;

/* harmony default export */ var fetch = __webpack_exports__["a"] = (service);

/***/ }),

/***/ "XMD6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XgS3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YDQt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("kV13");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("wUgx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__("KWv7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_kkt_weixin__ = __webpack_require__("lr8R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_kkt_weixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_kkt_weixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_kkt_domain__ = __webpack_require__("uraL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_kkt_domain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_kkt_domain__);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

// 创建路由对象
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  base: '/',
  mode: 'history',
  linkActiveClass: 'active',
  routes: __WEBPACK_IMPORTED_MODULE_2__routes__["default"],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});
router.beforeEach(function (to, from, next) {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // 百度pv统计
  if (to.path) {
    _hmt.push(['_trackPageview', to.fullPath]);
  }

  next();
});
// 路由导航后事件
router.afterEach(function (route) {
  // 延迟 100 毫秒执行
  setTimeout(function () {
    // 注册微信jssdk权限
    __WEBPACK_IMPORTED_MODULE_3_kkt_weixin___default.a.register({
      url: encodeURIComponent(location.href),
      api: __WEBPACK_IMPORTED_MODULE_4_kkt_domain___default.a.get() + '/basedata/wxsetting/getjssdk'
    });
  }, 100);
});

/* harmony default export */ __webpack_exports__["default"] = (router);

/***/ }),

/***/ "YjF/":
/***/ (function(module, exports) {

/*
* 获取浮点数
* @param {Number, Number} 数字 保留几位小数
* @return {String} 
*/
Math.float = function (val, number) {
  if (val === undefined) throw new Error('val is not defined');
  number = number || 2;
  var value = this.round(parseFloat(val) * this.pow(10, number)) / this.pow(10, number);
  var floatArr = value.toString().split('.');
  var intPart = floatArr[0];
  var floatPart = floatArr[1] || '';
  var index = number - floatPart.length;
  index = index > 0 ? index : 0;
  value = intPart + '.' + floatPart + Array(index).fill(0).join('');
  return value;
};

/***/ }),

/***/ "ZCgo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// 促销活动
var Index = function Index() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(15)]).then(__webpack_require__.bind(null, "C7qe"));
};
var Sale = function Sale() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(26)]).then(__webpack_require__.bind(null, "DRr2"));
};
var Resource = function Resource() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(30)]).then(__webpack_require__.bind(null, "Nzbf"));
};
var Jin = function Jin() {
  return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, "oHhD"));
};

/* harmony default export */ __webpack_exports__["default"] = ([{
  path: '/promotion',
  component: Index,
  meta: {
    title: '非洲中东旅游节'
  }
}, {
  path: '/promotion/sale',
  component: Sale,
  meta: {
    title: '抢购活动'
  }
}, {
  path: '/promotion/resource',
  component: Resource,
  meta: {
    title: '非洲中东旅游节'
  }
}, {
  path: '/promotion/jin',
  component: Jin,
  meta: {
    title: '锦鲤来了'
  }
}]);

/***/ }),

/***/ "e0oC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// demo 模块
var Index = function Index() {
  return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, "Lw3y"));
};
var Test = function Test() {
  return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, "Zmyh"));
};
/* harmony default export */ __webpack_exports__["default"] = ([{
  path: '/demo/index',
  component: Index
}, {
  path: '/demo/test',
  component: Test,
  meta: {
    keepAlive: true
  }
}]);

/***/ }),

/***/ "hpad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["j"] = getMarketcity;
/* harmony export (immutable) */ __webpack_exports__["l"] = getPorts;
/* harmony export (immutable) */ __webpack_exports__["h"] = getListforsale;
/* harmony export (immutable) */ __webpack_exports__["c"] = getCurrentUserInfo;
/* harmony export (immutable) */ __webpack_exports__["o"] = getSingleDetail;
/* harmony export (immutable) */ __webpack_exports__["f"] = getGroupMeeting;
/* harmony export (immutable) */ __webpack_exports__["d"] = getCustomerList;
/* harmony export (immutable) */ __webpack_exports__["a"] = createOrder;
/* harmony export (immutable) */ __webpack_exports__["p"] = orderDetail;
/* harmony export (immutable) */ __webpack_exports__["i"] = getListforwx;
/* harmony export (immutable) */ __webpack_exports__["b"] = createShare;
/* harmony export (immutable) */ __webpack_exports__["m"] = getShareDetail;
/* harmony export (immutable) */ __webpack_exports__["n"] = getShareList;
/* harmony export (immutable) */ __webpack_exports__["g"] = getLeaveAll;
/* harmony export (immutable) */ __webpack_exports__["e"] = getGroupDmDetail;
/* harmony export (immutable) */ __webpack_exports__["k"] = getNoticeFiles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_fetch__ = __webpack_require__("Vo7i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_kkt_domain__ = __webpack_require__("uraL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_kkt_domain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_kkt_domain__);



/*
* 团期列表
*/

// 获取目的国列表
function getMarketcity(params) {
	return __WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */].post('/marketing/marketcity/indexajax', params);
}

// 获取出发口岸列表
function getPorts(params) {
	return __WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */].post('/resources/city/listajax', params);
}

// 获取团期列表
function getListforsale(params) {
	return __WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */].get('/groups/planinfo/listforwxajax', { params: params });
}

// 获取当前登陆用户信息
function getCurrentUserInfo(params) {
	return __WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */].get('/user/manager/userinfo', { params: params });
}

/*
* 团期详情
*/

// 获取单个团期详情
function getSingleDetail(params) {
	return __WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */].get('/groups/planinfo/detailforwxajax', { params: params });
}

// 获取活动团期信息
function getGroupMeeting(params) {
	return __WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_1_kkt_domain___default.a.get('shareapi') + '/operate/meetingsale/detailajax', { params: params });
}

// 获取客户列表
function getCustomerList(params) {
	return __WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */].get('/customer/customercontact/search', { params: params });
}

// 新建订单
function createOrder(data) {
	return __WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */].post('/sale/order/add', data);
}

// 订单详情
function orderDetail(params) {
	return __WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */].get('/sale/order/detail', { params: params });
}

// 获取团期名类似的团期
function getListforwx(params) {
	return __WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */].get('/groups/planinfo/listforwxajax', { params: params });
}

// 信息转发
function createShare(data) {
	return __WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */].post('/share/share/add', data);
}

/*
* 分享
*/

// 获取分享详情
function getShareDetail(params) {
	return __WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */].get('/share/share/detail', { params: params });
}

// 获取分享列表
function getShareList(params) {
	return __WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */].get('/share/share/search', { params: params });
}

/*
* 获取留位清单
*/
function getLeaveAll(params) {
	return __WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */].get('/sale/order/searchall', { params: params });
}

// 获取团期dm单张详细数据
function getGroupDmDetail(params) {
	return __WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */].get('/dm/dmgroup/search', { params: params });
}

// 获取出团通知书
function getNoticeFiles(params) {
	return __WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */].get('/dm/dmattach/search', { params: params });
}

/***/ }),

/***/ "iPXC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setToken; });
/* unused harmony export setAppid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setShareId; });
/* unused harmony export setOpenid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setWetchInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setRegisterPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getWetchInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getIsRegister; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getShareId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("3cXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("sqb0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);



// cookie保存的天数
var inFifteenMinutes = new Date(new Date().getTime() + 15 * 60 * 1000);

var setToken = function setToken(token) {
  __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set('token', token, { expires: inFifteenMinutes });
};

var setAppid = function setAppid(token) {
  __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set('appid', token, { expires: inFifteenMinutes || 1 });
};

var setShareId = function setShareId(id) {
  __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set('share_userid', id, { expires: inFifteenMinutes || 1 });
};

var setOpenid = function setOpenid(token) {
  __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set('openid', token, { expires: inFifteenMinutes || 1 });
};

var setWetchInfo = function setWetchInfo(info) {
  __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set('wetchinfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(info), { expires: 1 });
};

var setRegisterPhone = function setRegisterPhone(token) {
  __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set('registerphone', token, { expires: inFifteenMinutes || 1 });
};

var getToken = function getToken() {
  var token = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('token');
  if (token) return token;else return false;
};

var getWetchInfo = function getWetchInfo() {
  var info = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('wetchinfo');
  return info ? JSON.parse(info) : '';
};

var getIsRegister = function getIsRegister() {
  var val = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('registerphone');
  if (val) return val;else return false;
};

var getShareId = function getShareId() {
  var val = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('share_userid');
  if (val) return val;else return false;
};

/***/ }),

/***/ "jnTS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// 用户
var Statistics = function Statistics() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(19)]).then(__webpack_require__.bind(null, "WO9/"));
};
var Login = function Login() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(__webpack_require__.bind(null, "PFpV"));
};
var Customer = function Customer() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(54)]).then(__webpack_require__.bind(null, "dVMV"));
};
var Password = function Password() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(40)]).then(__webpack_require__.bind(null, "zYm1"));
};
var Coupon = function Coupon() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(__webpack_require__.bind(null, "1tbR"));
};
var Register = function Register() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(50)]).then(__webpack_require__.bind(null, "J+J5"));
};

/* harmony default export */ __webpack_exports__["default"] = ([{
  path: '/user/statistics',
  component: Statistics,
  meta: {
    title: '数据统计'
  }
}, {
  path: '/user/login',
  component: Login,
  meta: {
    title: '登录',
    ignoreBackTop: true
  }
},
// {
//   path: '/user/customer',
//   component: Customer,
//   meta: {
//     title: '我的客户'
//   }
// },
{
  path: '/user/password',
  component: Password,
  meta: {
    title: '修改密码'
  }
}, {
  path: '/user/coupon',
  component: Coupon,
  meta: {
    title: '优惠券'
  }
}, {
  path: '/user/register',
  component: Register,
  meta: {
    title: '填写信息'
  }
}]);

/***/ }),

/***/ "k2xk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// 任务
var OrderConfirm = function OrderConfirm() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(58)]).then(__webpack_require__.bind(null, "do4t"));
};
var OrderConfirmDeatil = function OrderConfirmDeatil() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(42)]).then(__webpack_require__.bind(null, "gBxX"));
};

var ReturnGroup = function ReturnGroup() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(68)]).then(__webpack_require__.bind(null, "Isuz"));
};
var ReturnGroupDeatil = function ReturnGroupDeatil() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(48)]).then(__webpack_require__.bind(null, "1wLV"));
};

var CostChange = function CostChange() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(70)]).then(__webpack_require__.bind(null, "NzNm"));
};
var CostChangeDetail = function CostChangeDetail() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(43)]).then(__webpack_require__.bind(null, "4W1c"));
};

var RequestFund = function RequestFund() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(57)]).then(__webpack_require__.bind(null, "3VeY"));
};
var RequestFundDetail = function RequestFundDetail() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(49)]).then(__webpack_require__.bind(null, "JkCt"));
};

var Follow = function Follow() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(72)]).then(__webpack_require__.bind(null, "qixa"));
};
var FollowAdd = function FollowAdd() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(13)]).then(__webpack_require__.bind(null, "uOSX"));
};
var FollowDetail = function FollowDetail() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(34)]).then(__webpack_require__.bind(null, "n91h"));
};

/* harmony default export */ __webpack_exports__["default"] = ([{
  path: '/task/orderconfirm',
  component: OrderConfirm,
  meta: {
    title: '订单确认审核'
  }
}, {
  path: '/task/orderconfirm/detail',
  component: OrderConfirmDeatil,
  meta: {
    title: '订单确认审核'
  }
}, {
  path: '/task/returngroup',
  component: ReturnGroup,
  meta: {
    title: '退团审核'
  }
}, {
  path: '/task/returngroup/detail',
  component: ReturnGroupDeatil,
  meta: {
    title: '退团审核'
  }
}, {
  path: '/task/costchange',
  component: CostChange,
  meta: {
    title: '费用变更'
  }
}, {
  path: '/task/costchange/detail',
  component: CostChangeDetail,
  meta: {
    title: '费用变更审核'
  }
}, {
  path: '/task/requestfund',
  component: RequestFund,
  meta: {
    title: '请款单'
  }
}, {
  path: '/task/requestfund/detail',
  component: RequestFundDetail,
  meta: {
    title: '请款单审核'
  }
}, {
  path: '/task/follow',
  component: Follow,
  meta: {
    title: '跟进记录'
  }
}, {
  path: '/task/follow/add',
  component: FollowAdd,
  meta: {
    title: '添加跟进记录',
    ignoreBackTop: true
  }
}, {
  path: '/task/follow/detail',
  component: FollowDetail,
  meta: {
    title: '跟进记录'
  }
}]);

/***/ }),

/***/ "kvU+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kkt_domain__ = __webpack_require__("uraL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kkt_domain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kkt_domain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_cookie__ = __webpack_require__("iPXC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_fetch__ = __webpack_require__("Vo7i");
// 万众知识库
var Knowledge = function Knowledge() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(20)]).then(__webpack_require__.bind(null, "yBdi"));
};
var KnowledgeSearch = function KnowledgeSearch() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(21)]).then(__webpack_require__.bind(null, "+oE8"));
};
var ArticleDetail = function ArticleDetail() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(51)]).then(__webpack_require__.bind(null, "TaZo"));
};
var Training = function Training() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(38)]).then(__webpack_require__.bind(null, "B2B5"));
};
var TrainingDetail = function TrainingDetail() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(22)]).then(__webpack_require__.bind(null, "JLGU"));
};




var shouquan = function shouquan(to, from, next) {
  __WEBPACK_IMPORTED_MODULE_2__utils_fetch__["a" /* default */].get('/user/manager/userinfo').then(function (res) {
    if (res.data.id) {
      next();
    } else {
      throw 'error';
    }
  }).catch(function () {
    if (to.query.deal_user_id) Object(__WEBPACK_IMPORTED_MODULE_1__utils_cookie__["f" /* setShareId */])(to.query.deal_user_id);
    if (to.query.wxopenid) {
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_cookie__["g" /* setToken */])(to.query.wxopenid);
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_cookie__["e" /* setRegisterPhone */])(to.query.no_phone);
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_cookie__["h" /* setWetchInfo */])({
        wxopenid: to.query.wxopenid,
        contact_name: to.query.contact_name,
        head_group: to.query.head_group,
        head_path: to.query.head_path
      });
    }
    var token = to.query.wxopenid || Object(__WEBPACK_IMPORTED_MODULE_1__utils_cookie__["c" /* getToken */])();
    if (!token) {
      location.href = __WEBPACK_IMPORTED_MODULE_0_kkt_domain___default.a.get() + '/session/login/wxlogin2?successRedirect=' + encodeURIComponent(location.origin + to.fullPath);
    } else {
      next();
    }
  });
};

/* harmony default export */ __webpack_exports__["default"] = ([{
  path: '/school/knowledge',
  component: Knowledge,
  meta: {
    title: '万众知识库'
  }
}, {
  path: '/school/knowledge/search',
  component: KnowledgeSearch,
  meta: {
    title: '万众知识库'
  }
}, {
  path: '/school/knowledge/artdetail',
  component: ArticleDetail,
  meta: {
    title: '详情'
  }
}, {
  path: '/school/training',
  component: Training,
  // beforeEnter: shouquan,
  meta: {
    title: '培训课程'
  }
}, {
  path: '/school/training/detail',
  component: TrainingDetail,
  beforeEnter: shouquan,
  meta: {
    title: '课程详情'
  }
}]);

/***/ }),

/***/ "n4oI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ooxf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// 产品资料库
var Index = function Index() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(__webpack_require__.bind(null, "Pzm6"));
};
var Picture = function Picture() {
  return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, "xQ3s"));
};

/* harmony default export */ __webpack_exports__["default"] = ([{
  path: '/productdatabase',
  component: Index,
  name: 'database',
  meta: {
    title: '产品资料库',
    keepAlive: true
  }
}, {
  path: '/productdatabase/picture',
  component: Picture,
  name: 'picture',
  meta: {
    title: '产品资料库'
  }
}]);

/***/ }),

/***/ "roEk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_fetch__ = __webpack_require__("Vo7i");
// 首页
var Footer = function Footer() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, "gt06"));
};
var Home = function Home() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "+3bb"));
};
var HomeRecommend = function HomeRecommend() {
  return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, "9EWr"));
};
var Order = function Order() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(__webpack_require__.bind(null, "PeBT"));
};
var User = function User() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(18)]).then(__webpack_require__.bind(null, "2ZEZ"));
};
var Task = function Task() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(52)]).then(__webpack_require__.bind(null, "GQ92"));
};
var GonYinShan = function GonYinShan() {
  return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, "9cg7"));
};



/* harmony default export */ __webpack_exports__["default"] = ([{
  path: '/',
  component: Footer,
  redirect: '/home',
  children: [{
    path: 'home',
    component: Home,
    beforeEnter: function beforeEnter(to, from, next) {
      if (/^\/home(\/)?$/gi.test(to.path)) {
        __WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */].get('/user/manager/userinfo').then(function (res) {
          console.log(res.code == '2000');
          if (res.code == '2000') {
            if (res.data.type !== 1) {
              next('/home/gys');
            } else {
              next();
            }
          } else {
            next();
          }
        });
      } else {
        next();
      }
    },
    meta: {
      title: '首页'
    }
  }, {
    path: 'order',
    component: Order,
    meta: {
      title: '订单'
    }
  }, {
    path: '/user',
    component: User,
    meta: {
      title: '我的'
    }
  }, {
    path: '/task',
    component: Task,
    meta: {
      title: '任务'
    }
  }]
}, {
  path: '/home/recommend',
  component: HomeRecommend,
  meta: {
    title: '精品推荐'
  }
}, {
  path: '/home/gys',
  component: GonYinShan,
  meta: {
    title: '首页'
  }
}]);

/***/ }),

/***/ "ssSo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// 曝光 模块
var Group = function Group() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(__webpack_require__.bind(null, "jwiV"));
};
var Detail = function Detail() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, "ydlI"));
};
var DetailPromotion = function DetailPromotion() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, "ZpPq"));
};
var GroupPrice = function GroupPrice() {
  return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, "AQVf"));
};
var Intention = function Intention() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, "RHs6"));
};
var IntentionPromotion = function IntentionPromotion() {
  return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, "c1Hl"));
};
var Order = function Order() {
  return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, "uSRa"));
};
var PCdetail = function PCdetail() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(23)]).then(__webpack_require__.bind(null, "WZvD"));
};
var Share = function Share() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(__webpack_require__.bind(null, "ukp1"));
};
var NoticeFile = function NoticeFile() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(37)]).then(__webpack_require__.bind(null, "A/Ry"));
};

/* harmony default export */ __webpack_exports__["default"] = ([{
  path: '/exposure',
  redirect: '/exposure/group'
}, {
  path: '/exposure/group',
  component: Group,
  meta: {
    title: '跟团游'
  }
}, {
  path: '/exposure/detail',
  component: Detail,
  meta: {
    title: '产品详情'
  }
},
// 活动产品详情
{
  path: '/exposure/pdetail',
  component: DetailPromotion,
  meta: {
    title: '产品详情'
  }
}, {
  path: '/exposure/groupprice',
  component: GroupPrice,
  meta: {
    title: '团期价格'
  }
}, {
  path: '/exposure/intention',
  component: Intention,
  meta: {
    title: '意向留位'
  }
},
// 活动下单
{
  path: '/exposure/pintention',
  component: IntentionPromotion,
  meta: {
    title: '活动下单'
  }
}, {
  path: '/exposure/order',
  component: Order,
  meta: {
    title: '意向下单成功'
  }
}, {
  path: '/exposure/pcdetail',
  component: PCdetail,
  meta: {
    title: '阿联酋之行'
  }
}, {
  path: '/exposure/share',
  component: Share,
  meta: {
    title: '我的分享'
  }
}, {
  path: '/exposure/noticefile',
  component: NoticeFile,
  meta: {
    title: '出团通知书'
  }
}]);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.0096e0beb452ead1387c.js